module.exports = __webpack_public_path__ + "img/process-03.20ac9f4e.png";